import {
  AuthState,
  SET_CLEAN_USER,
  SET_ERROR_MESSAGE,
  SET_IS_ERROR,
  SET_LOADING_LOGIN,
  SET_USER,
  UserActionTypes,
} from "./types";

const INITIAL_STATE: AuthState = {
  idAD: null,
  token: "",
  isError: false,
  signed: false,
  loading: false,
  name: "",
  urlFoto: "",
  permissoes: [],
  userId: "",
  siglaNome: "",
  termosCondicoesRealizacaoAgendamentosAceito: false,
  termosClubeVantagensPolePositionAceito: false,
  deviceId: null,
  usuarioVivaz: false,
  usuarioBackofficeVivaz: false,
  usuarioComercial: false,
  usuarioCia: false,
  usuarioDiretor: false,
  usuarioGerenteOnline: false,
  codigoRegional365: "",
  idRegional: "",
  idRegionalSistemaOrigem: "",
  idCorretorSistemaOrigem: "",
  idCorretor2013: "",
  username: "",
  apelido: "",
  plantaoVendas: null,
  empresaVendas: [],
  idsBandeiras: [],
  consumerApi: null,
  idPerfilAcesso365: null,
  idEmpresaVendas365: null,
  codigoEmpresaVendas365: "",
  acessoAppFase1: null,
  acessoAppFase2: null,
  acessoAdmin: null,
  acessoMobile: null,
  acessoAppWeb: null,
  idEquipeCargo: null,
  idCorretorBolsao365: null,
  idCargo: null,
  idCargo2013: null,
  codigoCargo2013: null,
  dataNascimento: "",
  dataVencimentoCreci: "",
  fazAniversarioHoje: false,
  creciVencido: false,
  supervisorProduto: false,
  possuiToken3cplus: false,
  linkToken3cplus: "",
};

const userReducer = (state = INITIAL_STATE, action: UserActionTypes) => {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        idAD: "b3b71f59-ddaa-4dd3-a2a5-6bd0d9ff978c",
        userId: action.payload.userId,
        token: action.payload.token,
        isError: action.payload.isError,
        signed: action.payload.signed,
        name: action.payload.name,
        urlFoto: action.payload.urlFoto,
        permissoes: action.payload.permissoes,
        acessoAdmin: action.payload.acessoAdmin,
        acessoAppFase1: action.payload.acessoAppFase1,
        acessoAppFase2: action.payload.acessoAppFase2,
        acessoAppWeb: action.payload.acessoAppWeb,
        acessoMobile: action.payload.acessoMobile,
        siglaNome: action.payload.siglaNome,
        usuarioVivaz: action.payload.usuarioVivaz,
        usuarioBackofficeVivaz: action.payload.usuarioBackofficeVivaz,
        usuarioComercial: action.payload.usuarioComercial,
        usuarioCia: action.payload.usuarioCia,
        usuarioDiretor: action.payload.usuarioDiretor,
        usuarioGerenteOnline: action.payload.usuarioGerenteOnline,
        loading: false,
        idCorretorSistemaOrigem: action.payload.idCorretorSistemaOrigem,
        idRegionalSistemaOrigem: action.payload.idRegionalSistemaOrigem,
        idCorretor2013: action.payload.idCorretor2013,
        username: action.payload.username,
        empresaVendas: action.payload.empresaVendas,
        plantaoVendas: action.payload.plantaoVendas,
        apelido: action.payload.apelido,
        idsBandeiras: Array.isArray(action.payload.idsBandeiras)
          ? action.payload.idsBandeiras
          : [],
        codigoEmpresaVendas365: action.payload.codigoEmpresaVendas365,
        codigoCargo2013: action.payload.codigoCargo2013,
        idEquipeCargo: action.payload.idEquipeCargo,
        codigoRegional365: action.payload.codigoRegional365,
        idRegional: action.payload.idRegional,
        dataNascimento: action.payload.dataNascimento,
        dataVencimentoCreci: action.payload.dataVencimentoCreci,
        fazAniversarioHoje: action.payload.fazAniversarioHoje,
        creciVencido: action.payload.creciVencido,
        supervisorProduto: action.payload.supervisorProduto,
        possuiToken3cplus: action.payload.possuiToken3cplus,
        linkToken3cplus: action.payload.linkToken3cplus,
      };
    case SET_LOADING_LOGIN:
      return {
        ...state,
        loading: action.payload,
      };
    case SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.payload,
        isError: true,
      };
    case SET_IS_ERROR:
      return {
        ...state,
        loading: false,
        isError: action.payload,
      };
    case SET_CLEAN_USER:
      return {
        ...state,
        idAD: null,
        token: "",
        login: "",
        isError: false,
        signed: false,
        loading: false,
        name: "",
        avatar: "",
        siglaNome: "",
        permissoes: [],
        idCorretorSistemaOrigem: "",
        idRegionalSistemaOrigem: "",
        idCorretor2013: "",
        username: "",
        empresaVendas: null,
        plantaoVendas: null,
        apelido: null,
        codigoEmpresaVendas365: "",
        codigoCargo2013: null,
        idEquipeCargo: null,
        codigoRegional365: null,
        idRegional: null,
        usuarioBackofficeVivaz: false,
        possuiToken3cplus: false,
        linkToken3cplus: "",
      };
    default:
      return state;
  }
};
export default userReducer;
